import React, { Component } from "react";

import { Link } from "react-router-dom";
import privacy from "../../images/privacy.jpg";

function PrivacyPolicyBangla(props) {
  return (
    <div className="container mx-auto text-black bangla-font">
      <div className="privacy">
        <div className="container">
          <div className="mx-10 mt-5">
            <img src={privacy} width="100%" height="100%" alt="" />

            <h1 className="text-center mt-5 mb-5 text-4xl font-semibold">
            গোপনীয়তা নীতি
            </h1>
            <div>
              <p className="pb-5">
              ফ্রাই ফ্রেঞ্জিতে, আমরা আপনার গোপনীয়তা রক্ষা করতে প্রতিশ্রুতিবদ্ধ। আপনি যখন আমাদের ওয়েবসাইট পরিদর্শন করেন তখন আমরা কীভাবে আপনার ব্যক্তিগত তথ্য সংগ্রহ, ব্যবহার এবং সুরক্ষিত রাখি তা এই গোপনীয়তা নীতির রূপরেখা দেয়। আমাদের ওয়েবসাইট ব্যবহার করে, আপনি এই নীতিতে বর্ণিত অনুশীলনগুলিতে সম্মত হন।
              </p>
              <b style={{ fontSize: "20px", marginTop: "3%" }}>
                {" "}
                ১. তথ্য আমরা সংগ্রহ করি
              </b>
              <p>
              ১.১ ব্যক্তিগত তথ্য: আপনি যখন আমাদের ওয়েবসাইটের মাধ্যমে স্বেচ্ছায় আমাদেরকে প্রদান করেন তখন আমরা আপনার নাম, ইমেল ঠিকানা, ফোন নম্বর এবং বিতরণ ঠিকানার মতো ব্যক্তিগত তথ্য সংগ্রহ করতে পারি।
                <br />
                ১.২ ব্যবহারের তথ্য: আমরা আপনার আইপি ঠিকানা, ব্রাউজারের ধরন, অপারেটিং সিস্টেম এবং রেফারিং ওয়েবসাইট সহ আমাদের ওয়েবসাইটের সাথে আপনার মিথস্ক্রিয়া সম্পর্কে অ-ব্যক্তিগত তথ্য সংগ্রহ করতে পারি।
              </p>
            </div>

            <div className="mt-6">
              <b style={{ fontSize: "20px" }}> ২. তথ্যের ব্যবহার</b>
              <br />

              <p>
              ২.১ ব্যক্তিগত তথ্য: আমরা আপনার অর্ডারগুলি প্রক্রিয়া করতে এবং পূরণ করতে, আপনার অর্ডার বা অনুসন্ধানের বিষয়ে আপনার সাথে যোগাযোগ করতে এবং গ্রাহক সহায়তা প্রদান করতে আপনার ব্যক্তিগত তথ্য ব্যবহার করতে পারি।
              </p>
              <p>
              ২.২ ব্যবহারের তথ্য: আমরা প্রবণতা বিশ্লেষণ করতে, ওয়েবসাইট পরিচালনা করতে, ব্যবহারকারীদের গতিবিধি ট্র্যাক করতে এবং সামগ্রিক ব্যবহারের জন্য জনসংখ্যা সংক্রান্ত তথ্য সংগ্রহ করতে অ-ব্যক্তিগত তথ্য ব্যবহার করতে পারি। এই তথ্যটি আমাদের ওয়েবসাইট উন্নত করতে এবং আমাদের ব্যবহারকারীদের প্রয়োজন অনুসারে এটি তৈরি করতে সহায়তা করে।
              </p>
            </div>

            <div className="mt-6">
              <b style={{ fontSize: "20px" }}>৩. নিরাপত্তা</b>
              <br />

              <p>
              আমরা আপনার ব্যক্তিগত তথ্যের নিরাপত্তা নিশ্চিত করতে প্রতিশ্রুতিবদ্ধ। আমরা আপনার ব্যক্তিগত তথ্যের অননুমোদিত অ্যাক্সেস, পরিবর্তন, প্রকাশ বা ধ্বংস থেকে রক্ষা করার জন্য যুক্তিসঙ্গত নিরাপত্তা ব্যবস্থা বাস্তবায়ন করি।
              </p>
            </div>

            <div className="mt-6">
              <b style={{ fontSize: "20px" }}>৪. তৃতীয় পক্ষের প্রকাশ</b>
              <br />

              <p>
              আমরা আপনাকে অগ্রিম বিজ্ঞপ্তি না দেওয়া পর্যন্ত আমরা আপনার ব্যক্তিগত তথ্য বাইরের পক্ষের কাছে বিক্রি, বাণিজ্য বা স্থানান্তর করি না। যাইহোক, এতে বিশ্বস্ত তৃতীয় পক্ষের অন্তর্ভুক্ত নয় যারা আমাদের ওয়েবসাইট পরিচালনায়, আমাদের ব্যবসা পরিচালনা করতে বা আপনাকে সেবা দিতে আমাদের সহায়তা করে, যতক্ষণ না সেই পক্ষগুলি আপনার তথ্য গোপন রাখতে সম্মত হয়।
              </p>
            </div>

            <div className="mt-5">
              <b style={{ fontSize: "20px" }}> ৫. কুকিজ</b>
              <br />

              <p>
              আমাদের ওয়েবসাইট আপনার ব্রাউজিং অভিজ্ঞতা উন্নত করতে কুকিজ ব্যবহার করতে পারে. কুকিজ হল আপনার ডিভাইসে সংরক্ষিত ছোট টেক্সট ফাইল যা ওয়েবসাইটটিকে আপনার পছন্দ মনে রাখতে এবং কর্মক্ষমতা উন্নত করতে দেয়। আপনি কুকিজ স্বীকার বা অস্বীকার করা চয়ন করতে পারেন। আরো বিস্তারিত জানার জন্য অনুগ্রহ করে আমাদের কুকি নীতি পড়ুন।
              </p>
            </div>
            <div className="mt-5">
              <b style={{ fontSize: "20px" }}>
              ৬. তৃতীয় পক্ষের ওয়েবসাইটের লিঙ্ক
              </b>
              <br />

              <p>
              আমাদের ওয়েবসাইটে তৃতীয় পক্ষের ওয়েবসাইটের লিঙ্ক থাকতে পারে। আমরা এই ধরনের ওয়েবসাইটের গোপনীয়তা অনুশীলন বা বিষয়বস্তুর জন্য দায়ী নই। আমরা আপনাকে কোনো ব্যক্তিগত তথ্য প্রদান করার আগে সেই ওয়েবসাইটগুলির গোপনীয়তা নীতিগুলি পর্যালোচনা করতে উত্সাহিত করি৷
              </p>
            </div>
            <div className="mt-5">
              <b style={{ fontSize: "20px" }}>
              ৭. এই গোপনীয়তা নীতি পরিবর্তন
              </b>
              <br />

              <p>
              আমরা যে কোনো সময় এই গোপনীয়তা নীতি পরিবর্তন করার অধিকার সংরক্ষণ করি। যেকোনো পরিবর্তন এই পৃষ্ঠায় পোস্ট করা হবে, এবং আপডেট করা নীতি পোস্ট করার সাথে সাথেই কার্যকর হবে।
              </p>
            </div>
            <div className="mt-5">
              <b style={{ fontSize: "20px" }}>৮. আমাদের সাথে যোগাযোগ করুন</b>
              <br />

              <p>
              এই গোপনীয়তা নীতি সম্পর্কে আপনার কোন প্রশ্ন বা উদ্বেগ থাকলে, অনুগ্রহ করে <span className="text-orange-500">eat@fryfrenzy.com</span> এ আমাদের সাথে যোগাযোগ করুন
              </p>
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyBangla;
